import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import { TradePreference } from 'types'

import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSSeparator from 'designSystem/components/PDSSeparator/PDSSeparator'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_WEIGHT } from 'designSystem/foundations/constants/fontWeight'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  isOpen: boolean
  onClose: () => void
  handleSubmit: (tradePreference: TradePreference) => void
}

function TaxBudgetTradingCadenceModal({
  isOpen,
  onClose,
  handleSubmit,
}: Props) {
  return (
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={() => {
        onClose()
      }}
      size="sm"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader />
        <ModalCloseButton />
        <ModalBody paddingX={0}>
          <PDSFlexBox flexDirection="column" gap={SIZE.s20} paddingX={SIZE.s32}>
            <PDSText
              fontWeight={FONT_WEIGHT.semibold}
              color={COLOR.textPrimary}
              size="lg"
            >
              Increase Gains Budget & Place Trades?
            </PDSText>
            <PDSText
              color={COLOR.textSecondary}
              fontWeight={FONT_WEIGHT.regular}
              variant="p"
              size="md"
            >
              You’re about to increase this portfolio’s gains budget.
            </PDSText>
            <PDSText
              color={COLOR.textSecondary}
              fontWeight={FONT_WEIGHT.regular}
              variant="p"
              size="md"
            >
              You can choose to have Pave Pro trade the linked portfolios’ new
              suggestions immediately or on their existing monthly trade
              cadence.
            </PDSText>
          </PDSFlexBox>
        </ModalBody>
        <PDSSeparator marginTop={SIZE.s16} />
        <ModalFooter>
          <PDSFlexBox
            flexDirection="column"
            padding={SIZE.s32}
            gap={SIZE.s8}
            width="100%"
          >
            <PDSButton
              text="Trade on Existing Cadence"
              type="submit"
              onClick={() => handleSubmit(TradePreference.MONTHLY_CADENCE)}
            />
            <PDSButton
              text="Trade Immediately"
              type="submit"
              variant="secondary"
              onClick={() => handleSubmit(TradePreference.NOW)}
            />
            <PDSButton text="Cancel" variant="tertiary" onClick={onClose} />
          </PDSFlexBox>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
export default TaxBudgetTradingCadenceModal
